/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
  CheckboxGroupInput,
  RadioButtonGroupInput,
  DateTimeInput,
  required,
  minValue,
  maxValue,
  useInput,
} from 'react-admin';
import '../user-styles.css';
import { getFormattedDate, getLocations } from '../utils';

const validateProducts = [required()];
const validateLocations = [required()];
const validateCode = [required()];
const validateCodeType = [required()];
const validateValue = [required()];
const validateDate = [required()];
const validateCapacity = [required()];
const validateNoOfMembershipMonths = [required(), minValue(1), maxValue(120)];

const MutualExclusiveCheckboxGroup = (props) => {
  const { input: { value, onChange }, ...rest } = useInput(props);
  
  const handleChange = (newValue) => {
    if (newValue.includes('nonMemberPricingOnly') && newValue.includes('newMembersOnly')) {
      const wasNonMemberSelected = value && value.includes('nonMemberPricingOnly');
      const wasNewMembersSelected = value && value.includes('newMembersOnly');
      
              if (!wasNonMemberSelected && newValue.includes('nonMemberPricingOnly')) {
        newValue = newValue.filter(v => v !== 'newMembersOnly');
      } else if (!wasNewMembersSelected && newValue.includes('newMembersOnly')) {
        newValue = newValue.filter(v => v !== 'nonMemberPricingOnly');
      }
    }
    
    onChange(newValue);
  };

  return (
    <CheckboxGroupInput
      {...rest}
      source={props.source}
      choices={props.choices}
      onChange={handleChange}
    />
  );
};

const ProductRestrictedCheckboxGroup = (props) => {
  const { input: { value, onChange }, ...rest } = useInput(props);
  
  const restrictionsInput = useInput({ source: 'restrictions' });
  const selectedRestrictions = restrictionsInput.input.value || [];
  
  useEffect(() => {
    if (value && value.length > 0) {
      let updatedValue = [...value];
      
      const hasNonMemberPricingOnly = selectedRestrictions.includes('nonMemberPricingOnly');
      
      const hasNewMembersOnly = selectedRestrictions.includes('newMembersOnly');
      
      if (hasNonMemberPricingOnly) {
        if (updatedValue.includes('membership')) {
          updatedValue = updatedValue.filter(v => v !== 'membership');
        }
        if (updatedValue.includes('gift')) {
          updatedValue = updatedValue.filter(v => v !== 'gift');
        }
      } else if (hasNewMembersOnly) {
        if (updatedValue.includes('gift')) {
          updatedValue = updatedValue.filter(v => v !== 'gift');
        }
      }
      
      if (JSON.stringify(updatedValue) !== JSON.stringify(value)) {
        onChange(updatedValue);
      }
    }
  }, [selectedRestrictions, value, onChange]);
  
  const handleChange = (newValue) => {
    let filteredValue = [...newValue];
    
    const hasNonMemberPricingOnly = selectedRestrictions.includes('nonMemberPricingOnly');
    
    const hasNewMembersOnly = selectedRestrictions.includes('newMembersOnly');
    
    if (hasNonMemberPricingOnly) {
      if (filteredValue.includes('membership')) {
        filteredValue = filteredValue.filter(v => v !== 'membership');
      }
      if (filteredValue.includes('gift')) {
        filteredValue = filteredValue.filter(v => v !== 'gift');
      }
    } else if (hasNewMembersOnly) {
      if (filteredValue.includes('gift')) {
        filteredValue = filteredValue.filter(v => v !== 'gift');
      }
    }
    
    onChange(filteredValue);
  };

  return (
    <CheckboxGroupInput
      {...rest}
      source={props.source}
      choices={props.choices}
      onChange={handleChange}
    />
  );
};

export const PromoCreate = props => {
  const [promoProducts, setPromoProducts] = useState([]);

  const workLocations = JSON.parse(localStorage.getItem('userWorkLocations'));

  const todayDate = getFormattedDate(new Date());

  return (
    <Create {...props}>
      <SimpleForm>
        <TextInput source="code" label="Promo Code" validate={validateCode} />
        <RadioButtonGroupInput
          source="type"
          label="Code Type"
          choices={[
            { id: 1, name: '$ Off' },
            { id: 2, name: '% Off' },
          ]}
          validate={validateCodeType}
        />
        <TextInput
          source="discount_amount"
          label="Code Value ($/%)"
          validate={validateValue}
        />
        <DateTimeInput
          source="promo_start_date"
          defaultValue={todayDate}
          label="Start Date"
          validate={validateDate}
        />
        <DateTimeInput
          source="promo_end_date"
          defaultValue={todayDate}
          label="End Date"
          validate={validateDate}
        />
        <TextInput source="capacity" validate={ validateCapacity } />
        <MutualExclusiveCheckboxGroup
          source="restrictions"
          choices={[
            { id: 'nonMemberPricingOnly', name: 'Non-Member Pricing Only?' },
            { id: 'newMembersOnly', name: 'New Members Only?' },
            { id: 'firstTimeGuest', name: 'First-Time Guests?' },
            { id: 'oneTimePerGuest', name: 'One-time Use per Guest?' },
          ]}
        />
        <ProductRestrictedCheckboxGroup
          source="products"
          validate={validateProducts}
          onChange={e => setPromoProducts(e)}
          choices={[
            { id: 'appointment', name: 'appointment' },
            { id: 'gift', name: 'gift' },
            { id: 'membership', name: 'membership' },
          ]}
        />
       
        <CheckboxGroupInput
          source="shops"
          validate={validateLocations}
          choices={getLocations(workLocations)}
        />
        <TextInput source="notes" />
        {promoProducts && promoProducts.includes('gift') && (
          <TextInput source="minimum_gift_amount" />
        )}
        {promoProducts && promoProducts.includes('appointment') && (
          <>
            <CheckboxGroupInput
              source="days"
              choices={[
                { id: 1, name: 'Monday' },
                { id: 2, name: 'Tuesday' },
                { id: 3, name: 'Wednesday' },
                { id: 4, name: 'Thursday' },
                { id: 5, name: 'Friday' },
                { id: 6, name: 'Saturday' },
                { id: 0, name: 'Sunday' },
              ]}
            />
            <DateTimeInput
              source="appt_start_date"
              label="Appointment Start Date/Time"
            />
            <DateTimeInput
              source="appt_end_date"
              label="Appointment End Date/Time"
            />
          </>
        )}
        {promoProducts && promoProducts.includes('membership') && (
          <TextInput
            label="# Of Membership Months to Discount"
            source="membership_months_to_discount"
            validate={validateNoOfMembershipMonths}
          />
        )}
      </SimpleForm>
    </Create>
  );
};
